import React, { Fragment } from 'react';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import FaqSection from '../../components/FaqSection/FaqSection';

import MapSection from '../../components/MapSection/MapSection';

import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'
import MyForm from '../../components/GetTouchSection/MyForm';
import Footer from '../../components/footer/Footer';

const FaqPage = () => {
    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'International Logistics'} pagesub={'Faq'} />
            <FaqSection hclass={'wpo-faq-section section-padding'} />
            <section className="wpo-get-touch-section-s2 section-padding pt-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                           <MyForm />
                        </div>
                    </div>
                </div>
            </section>
            <MapSection />
            {/* <CtaSection hclass={'wpo-cta-section-s2'} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    );
};

export default FaqPage;
